module.exports = __webpack_public_path__ + "static/media/MetroBrandsLogo.31dea0ed.png";